// eslint-disable-next-line no-unused-vars
import React, { useState } from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Container from "../layout/container"
import PhilipCard from "./philip-card"

const SeelkersTestimonyMobile = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query SeelkersTestimonyMobileQuery {
      mobile: file(relativePath: { eq: "backgrounds/circles-dark.png" }) {
        childImageSharp {
          fluid(maxWidth: 376) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <BackgroundImage
      fluid={data.mobile.childImageSharp.fluid}
      sx={{
        backgroundSize: `cover`,
        backgroundRepeat: `no-repeat`,
        backgroundPosition: `center bottom`,
      }}
    >
      <Container
        overrideCSS={{
          height: `100%`,
          display: `flex`,
          justifyContent: `center`,
          alignItems: `center`,
          flexDirection: ["column", "column", "row", "row"],
        }}
      >
        <PhilipCard langKey={langKey} />
      </Container>
    </BackgroundImage>
  )
}

export default SeelkersTestimonyMobile
